export default __webpack_public_path__ + "static/media/no_more_guessing_1.42c2799f.jpg";